<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="background"
      d="M9 25.5C4.30558 25.5 0.5 21.6944 0.5 17V9C0.5 4.30558 4.30558 0.5 9 0.5H17C21.6944 0.5 25.5 4.30558 25.5 9V17C25.5 21.6944 21.6944 25.5 17 25.5H9Z"
    />
    <path
      id="check"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5239 13.2938L10.3108 18.0806C10.6202 18.39 11.1219 18.39 11.4313 18.0806L20.4805 9.0314C20.7897 8.72218 20.7897 8.22008 20.4805 7.91087C20.1713 7.60165 19.6692 7.60165 19.36 7.91087C19.36 7.91087 12.8452 14.4257 10.871 16.3999C9.60731 15.1361 6.64444 12.1732 6.64444 12.1732C6.33522 11.864 5.83312 11.864 5.5239 12.1732C5.21469 12.4825 5.21469 12.9846 5.5239 13.2938Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckboxOn'
};
</script>

<style scoped lang="scss">
svg path {
  &#background {
    fill: currentColor;
    stroke: currentColor;
  }
}
</style>
